<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道北塔</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-tower" content="NT1#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/tower/northChannelNorthTower"></router-link>
          </el-tooltip>
          <div class="stati sta-tower">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNT1Dehumidifier,
                    humidityAllowedMaxNT1Dehumidifier,
                    runningDehumidifierNT1,
                    malfunctionDehumidifierNT1
                  )
                }}
              </div>
              <div :class="errorNT1Dehumidifier" class="state-info right-pos">
                <p>北航道北塔除湿机</p>
                <p>
                  <span>{{ humidityNT1Dehumidifier | toFixed }}% {{ temperatureNT1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNT1" effect="light" placement="right"> -->
                  <span :class="runningClassNT1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT4, humidityAllowedMaxT4) }}
              </div>
              <div :class="errorT4" class="state-info right-pos">
                <p>塔内温湿度4</p>
                <p>
                  <span>{{ humidityT4 | toFixed }}% {{ temperatureT4 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT3, humidityAllowedMaxT3) }}
              </div>
              <div :class="errorT3" class="state-info left-pos">
                <p>塔内温湿度3</p>
                <p>
                  <span>{{ humidityT3 | toFixed }}% {{ temperatureT3 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT2, humidityAllowedMaxT2) }}
              </div>
              <div :class="errorT2" class="state-info right-pos">
                <p>塔内温湿度2</p>
                <p>
                  <span>{{ humidityT2 | toFixed }}% {{ temperatureT2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-t1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorT1, humidityAllowedMaxT1) }}
              </div>
              <div :class="errorT1" class="state-info left-pos">
                <p>塔内温湿度1</p>
                <p>
                  <span>{{ humidityT1 | toFixed }}% {{ temperatureT1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>北航道北塔区钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">传感器组</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">宁波</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="NN1#/NN2#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/nn1nn2"></router-link>
          </el-tooltip>
          <div class="stati sta-left-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNN1Dehumidifier,
                    humidityAllowedMaxNN1Dehumidifier,
                    runningDehumidifierNN1,
                    malfunctionDehumidifierNN1
                  )
                }}
              </div>
              <div :class="errorNN1Dehumidifier" class="state-info right-pos">
                <p>NN1#除湿机</p>
                <p>
                  <span>{{ humidityNN1Dehumidifier | toFixed }}% {{ temperatureNN1Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNN1" effect="light" placement="right"> -->
                  <span :class="runningClassNN1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNN2Dehumidifier,
                    humidityAllowedMaxNN2Dehumidifier,
                    runningDehumidifierNN2,
                    malfunctionDehumidifierNN2
                  )
                }}
              </div>
              <div :class="errorNN2Dehumidifier" class="state-info left-pos">
                <p>NN2#除湿机</p>
                <p>
                  <span>{{ humidityNN2Dehumidifier | toFixed }}% {{ temperatureNN2Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNN2" effect="light" placement="right"> -->
                  <span :class="runningClassNN2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-right" content="NN3#/NN4#除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/hangzhouwan/steelBox/nn3nn4"></router-link>
          </el-tooltip>
          <div class="stati sta-right-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNN3Dehumidifier,
                    humidityAllowedMaxNN3Dehumidifier,
                    runningDehumidifierNN3,
                    malfunctionDehumidifierNN3
                  )
                }}
              </div>
              <div :class="errorNN3Dehumidifier" class="state-info right-pos">
                <p>NN3#除湿机</p>
                <p>
                  <span>{{ humidityNN3Dehumidifier | toFixed }}% {{ temperatureNN3Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNN3" effect="light" placement="right"> -->
                  <span :class="runningClassNN3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorNN4Dehumidifier,
                    humidityAllowedMaxNN4Dehumidifier,
                    runningDehumidifierNN4,
                    malfunctionDehumidifierNN4
                  )
                }}
              </div>
              <div :class="errorNN4Dehumidifier" class="state-info left-pos">
                <p>NN4#除湿机</p>
                <p>
                  <span>{{ humidityNN4Dehumidifier | toFixed }}% {{ temperatureNN4Dehumidifier | toFixed }}°C</span>
                  <!-- <el-tooltip :content="runningTooltipNN4" effect="light" placement="right"> -->
                  <span :class="runningClassNN4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-n04">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorN04, humidityAllowedMaxN04) }}
              </div>
              <div :class="errorN04" class="state-info right-pos">
                <p>N04梁段传感器</p>
                <p>
                  <span>{{ humidityN04 | toFixed }}% {{ temperatureN04 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB12, humidityAllowedMaxNB12) }}
              </div>
              <div :class="errorNB12" class="state-info right-pos">
                <p>NB12梁段传感器</p>
                <p>
                  <span>{{ humidityNB12 | toFixed }}% {{ temperatureNB12 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB8, humidityAllowedMaxNB8) }}
              </div>
              <div :class="errorNB8" class="state-info right-pos">
                <p>NB8梁段传感器</p>
                <p>
                  <span>{{ humidityNB8 | toFixed }}% {{ temperatureNB8 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB5, humidityAllowedMaxNB5) }}
              </div>
              <div :class="errorNB5" class="state-info right-pos">
                <p>NB5梁段传感器</p>
                <p>
                  <span>{{ humidityNB5 | toFixed }}% {{ temperatureNB5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nb2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNB2, humidityAllowedMaxNB2) }}
              </div>
              <div :class="errorNB2" class="state-info right-pos">
                <p>NB2梁段传感器</p>
                <p>
                  <span>{{ humidityNB2 | toFixed }}% {{ temperatureNB2 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ1, humidityAllowedMaxNZ1) }}
              </div>
              <div :class="errorNZ1" class="state-info left-pos">
                <p>NZ1梁段传感器</p>
                <p>
                  <span>{{ humidityNZ1 | toFixed }}% {{ temperatureNZ1 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ5, humidityAllowedMaxNZ5) }}
              </div>
              <div :class="errorNZ5" class="state-info left-pos">
                <p>NZ5梁段传感器</p>
                <p>
                  <span>{{ humidityNZ5 | toFixed }}% {{ temperatureNZ5 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ8, humidityAllowedMaxNZ8) }}
              </div>
              <div :class="errorNZ8" class="state-info left-pos">
                <p>NZ8梁段传感器</p>
                <p>
                  <span>{{ humidityNZ8 | toFixed }}% {{ temperatureNZ8 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 sensor-nz11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorNZ11, humidityAllowedMaxNZ11) }}
              </div>
              <div :class="errorNZ11" class="state-info left-pos">
                <p>NZ11梁段传感器</p>
                <p>
                  <span>{{ humidityNZ11 | toFixed }}% {{ temperatureNZ11 | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //humidity, temperature
      humidityNN1Dehumidifier: "--",
      humidityNN2Dehumidifier: "--",
      humidityNN3Dehumidifier: "--",
      humidityNN4Dehumidifier: "--",
      humidityNT1Dehumidifier: "--",
      temperatureNN1Dehumidifier: "--",
      temperatureNN2Dehumidifier: "--",
      temperatureNN3Dehumidifier: "--",
      temperatureNN4Dehumidifier: "--",
      temperatureNT1Dehumidifier: "--",

      humidityN04: "--",
      humidityNB12: "--",
      humidityNB8: "--",
      humidityNB5: "--",
      humidityNB2: "--",
      humidityNZ1: "--",
      humidityNZ5: "--",
      humidityNZ8: "--",
      humidityNZ11: "--",
      humidityT1: "--",
      humidityT2: "--",
      humidityT3: "--",
      humidityT4: "--",
      temperatureN04: "--",
      temperatureNB12: "--",
      temperatureNB8: "--",
      temperatureNB5: "--",
      temperatureNB2: "--",
      temperatureNZ1: "--",
      temperatureNZ5: "--",
      temperatureNZ8: "--",
      temperatureNZ11: "--",
      temperatureT1: "--",
      temperatureT2: "--",
      temperatureT3: "--",
      temperatureT4: "--",

      //running
      runningDehumidifierNN1: "--",
      runningDehumidifierNN2: "--",
      runningDehumidifierNN3: "--",
      runningDehumidifierNN4: "--",
      runningDehumidifierNT1: "--",

      //malfunction
      malfunctionDehumidifierNN1: "--",
      malfunctionDehumidifierNN2: "--",
      malfunctionDehumidifierNN3: "--",
      malfunctionDehumidifierNN4: "--",
      malfunctionDehumidifierNT1: "--",

      //error
      errorNN1Dehumidifier: "--",
      errorNN2Dehumidifier: "--",
      errorNN3Dehumidifier: "--",
      errorNN4Dehumidifier: "--",
      errorNT1Dehumidifier: "--",

      errorN04: "--",
      errorNB12: "--",
      errorNB8: "--",
      errorNB5: "--",
      errorNB2: "--",
      errorNZ1: "--",
      errorNZ5: "--",
      errorNZ8: "--",
      errorNZ11: "--",
      errorT1: "--",
      errorT2: "--",
      errorT3: "--",
      errorT4: "--",

      // //running tooltip and class
      // runningTooltipNN1: "--",
      // runningTooltipNN2: "--",
      // runningTooltipNN3: "--",
      // runningTooltipNN4: "--",
      // runningTooltipNT1: "--",

      //running class
      runningClassNN1: "",
      runningClassNN2: "",
      runningClassNN3: "",
      runningClassNN4: "",
      runningClassNT1: "",

      //humidity allowed max
      humidityAllowedMaxNN1Dehumidifier: "--",
      humidityAllowedMaxNN2Dehumidifier: "--",
      humidityAllowedMaxNN3Dehumidifier: "--",
      humidityAllowedMaxNN4Dehumidifier: "--",
      humidityAllowedMaxNT1Dehumidifier: "--",
      humidityAllowedMaxN04: "--",
      humidityAllowedMaxNB12: "--",
      humidityAllowedMaxNB8: "--",
      humidityAllowedMaxNB5: "--",
      humidityAllowedMaxNB2: "--",
      humidityAllowedMaxNZ1: "--",
      humidityAllowedMaxNZ5: "--",
      humidityAllowedMaxNZ8: "--",
      humidityAllowedMaxNZ11: "--",
      humidityAllowedMaxT1: "--",
      humidityAllowedMaxT2: "--",
      humidityAllowedMaxT3: "--",
      humidityAllowedMaxT4: "--",

      //humidity tooltip error
      humidityTooltipErrorNN1Dehumidifier: "--",
      humidityTooltipErrorNN2Dehumidifier: "--",
      humidityTooltipErrorNN3Dehumidifier: "--",
      humidityTooltipErrorNN4Dehumidifier: "--",
      humidityTooltipErrorNT1Dehumidifier: "--",
      humidityTooltipErrorN04: "--",
      humidityTooltipErrorNB12: "--",
      humidityTooltipErrorNB8: "--",
      humidityTooltipErrorNB5: "--",
      humidityTooltipErrorNB2: "--",
      humidityTooltipErrorNZ1: "--",
      humidityTooltipErrorNZ5: "--",
      humidityTooltipErrorNZ8: "--",
      humidityTooltipErrorNZ11: "--",
      humidityTooltipErrorT1: "--",
      humidityTooltipErrorT2: "--",
      humidityTooltipErrorT3: "--",
      humidityTooltipErrorT4: "--",

      //humidity, temperature, running -> id
      dataNameIdDict: {
        //humidity, temperature
        humidityNN1Dehumidifier: "ca13a89c-9a39-4a28-8356-51f58982e30a",
        humidityNN2Dehumidifier: "764709cd-f38e-410d-93c6-4e6d402919c1",
        humidityNN3Dehumidifier: "4cc3af06-4e3e-4daa-8dbe-f019ae49a73d",
        humidityNN4Dehumidifier: "b288e941-56f5-45e5-b0d0-1cb6f25f3a50",
        humidityNT1Dehumidifier: "16198424-bc59-4d5c-aabb-031cb783288d",
        temperatureNN1Dehumidifier: "db61e3ae-b60e-4f1f-822d-cba8dcbc96d5",
        temperatureNN2Dehumidifier: "98aef6f7-5ae9-4938-888f-677954a2a033",
        temperatureNN3Dehumidifier: "85ba498d-75d1-45dc-aff2-1816f7d95ce1",
        temperatureNN4Dehumidifier: "f3e11fd4-57bb-4888-90ab-6e47c07b49ed",
        temperatureNT1Dehumidifier: "6b5563a7-0a90-403a-b5e3-57fd89a293f0",

        humidityN04: "bf13765e-b024-42e6-8c0f-f1656945096f",
        humidityNB12: "b617c5e1-7bef-464f-962f-ff9714ac004a",
        humidityNB8: "eefa73f3-2030-445d-9fdd-29e0edab2d55",
        humidityNB5: "10ade259-104c-487a-b3d7-33227ffb5005",
        humidityNB2: "f66f9d29-20a5-4ad5-a5d1-0c2931db7832",
        humidityNZ1: "1201b049-777d-4337-bd8d-0cb9b970c15e",
        humidityNZ5: "0a09b5b0-8441-4218-b9ad-5850f64a83a5",
        humidityNZ8: "47fb3abe-699f-4827-bbe6-d36913b94e1b",
        humidityNZ11: "cde0f349-2ba2-4b21-abc6-b52d0bd576c2",
        humidityT1: "e6a9e99e-55df-44ad-aa16-e2f8dbf0e7ec",
        humidityT2: "d5da7010-7036-49dd-b0cd-0908c3199e27",
        humidityT3: "bcabb070-c6b1-4175-a662-9e7bb499464c",
        humidityT4: "ed2c0cbd-6ebb-4918-b06a-795ca6e5016c",
        temperatureN04: "1bb702d2-8b25-4397-bfd6-1bb60fe48488",
        temperatureNB12: "a593af66-93b1-43ec-8cbc-de33df511397",
        temperatureNB8: "6b0d2467-e38a-4f1f-80e6-047078066767",
        temperatureNB5: "5e1c46a3-da78-4565-ba97-d447838ed3e3",
        temperatureNB2: "57852bb1-f6a7-4f86-acde-089ae1da2ea4",
        temperatureNZ1: "1907ee6b-c8d5-46f6-adca-6c313d91cdbb",
        temperatureNZ5: "734c1014-2cd3-4446-8c39-89012d8b227f",
        temperatureNZ8: "640bb29d-7d73-4cc6-8b78-ba4c4f9787b4",
        temperatureNZ11: "3caad2be-5e8c-4616-8fab-a8c8cd8c3203",
        temperatureT1: "3ea22f02-e81e-4440-9454-5c793ac5c43f",
        temperatureT2: "e6c3361a-af94-4796-aff6-0d2f3a0f44cc",
        temperatureT3: "7a4ad8e6-5c1d-44c5-a68e-c6dc73682ac2",
        temperatureT4: "83035a04-ec13-4658-9a70-dc41fcd8cbe3",

        //running
        runningDehumidifierNN1: "bb38817b-6903-4e9a-a6fc-0d160ea55046",
        runningDehumidifierNN2: "03e97cae-3e35-4370-9a13-ca8ad4eb2129",
        runningDehumidifierNN3: "b1e0b711-f99c-4bdd-bfe5-c569ab742d83",
        runningDehumidifierNN4: "416c8760-78f6-4b30-86a9-c68122d8a757",
        runningDehumidifierNT1: "6c57a146-4bd6-47a2-955a-65c1f77dcd6c",

        //malfunction
        malfunctionDehumidifierNN1: "1658d928-dbf8-423c-8b75-55c21a038c44",
        malfunctionDehumidifierNN2: "31fddd83-93e2-427c-bb27-9c6793c4f61c",
        malfunctionDehumidifierNN3: "139f2c12-6c80-40f6-bc03-b5b256ab57b1",
        malfunctionDehumidifierNN4: "f9aeee6f-20f6-4b0c-83eb-1da49e40e4a3",
        malfunctionDehumidifierNT1: "f64e596e-8743-4978-ac0f-53244d513a46",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxNN1Dehumidifier: "ca13a89c-9a39-4a28-8356-51f58982e30a",
        humidityAllowedMaxNN2Dehumidifier: "764709cd-f38e-410d-93c6-4e6d402919c1",
        humidityAllowedMaxNN3Dehumidifier: "4cc3af06-4e3e-4daa-8dbe-f019ae49a73d",
        humidityAllowedMaxNN4Dehumidifier: "b288e941-56f5-45e5-b0d0-1cb6f25f3a50",
        humidityAllowedMaxNT1Dehumidifier: "16198424-bc59-4d5c-aabb-031cb783288d",
        humidityAllowedMaxN04: "bf13765e-b024-42e6-8c0f-f1656945096f",
        humidityAllowedMaxNB12: "b617c5e1-7bef-464f-962f-ff9714ac004a",
        humidityAllowedMaxNB8: "eefa73f3-2030-445d-9fdd-29e0edab2d55",
        humidityAllowedMaxNB5: "10ade259-104c-487a-b3d7-33227ffb5005",
        humidityAllowedMaxNB2: "f66f9d29-20a5-4ad5-a5d1-0c2931db7832",
        humidityAllowedMaxNZ1: "1201b049-777d-4337-bd8d-0cb9b970c15e",
        humidityAllowedMaxNZ5: "0a09b5b0-8441-4218-b9ad-5850f64a83a5",
        humidityAllowedMaxNZ8: "47fb3abe-699f-4827-bbe6-d36913b94e1b",
        humidityAllowedMaxNZ11: "cde0f349-2ba2-4b21-abc6-b52d0bd576c2",
        humidityAllowedMaxT1: "e6a9e99e-55df-44ad-aa16-e2f8dbf0e7ec",
        humidityAllowedMaxT2: "d5da7010-7036-49dd-b0cd-0908c3199e27",
        humidityAllowedMaxT3: "bcabb070-c6b1-4175-a662-9e7bb499464c",
        humidityAllowedMaxT4: "ed2c0cbd-6ebb-4918-b06a-795ca6e5016c",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        //humidity, temperature
        humidityNN1Dehumidifier: "errorNN1Dehumidifier",
        humidityNN2Dehumidifier: "errorNN2Dehumidifier",
        humidityNN3Dehumidifier: "errorNN3Dehumidifier",
        humidityNN4Dehumidifier: "errorNN4Dehumidifier",
        humidityNT1Dehumidifier: "errorNT1Dehumidifier",
        temperatureNN1Dehumidifier: "errorNN1Dehumidifier",
        temperatureNN2Dehumidifier: "errorNN2Dehumidifier",
        temperatureNN3Dehumidifier: "errorNN3Dehumidifier",
        temperatureNN4Dehumidifier: "errorNN4Dehumidifier",
        temperatureNT1Dehumidifier: "errorNT1Dehumidifier",

        humidityN04: "errorN04",
        humidityNB12: "errorNB12",
        humidityNB8: "errorNB8",
        humidityNB5: "errorNB5",
        humidityNB2: "errorNB2",
        humidityNZ1: "errorNZ1",
        humidityNZ5: "errorNZ5",
        humidityNZ8: "errorNZ8",
        humidityNZ11: "errorNZ11",
        humidityT1: "errorT1",
        humidityT2: "errorT2",
        humidityT3: "errorT3",
        humidityT4: "errorT4",
        temperatureN04: "errorN04",
        temperatureNB12: "errorNB12",
        temperatureNB8: "errorNB8",
        temperatureNB5: "errorNB5",
        temperatureNB2: "errorNB2",
        temperatureNZ1: "errorNZ1",
        temperatureNZ5: "errorNZ5",
        temperatureNZ8: "errorNZ8",
        temperatureNZ11: "errorNZ11",
        temperatureT1: "errorT1",
        temperatureT2: "errorT2",
        temperatureT3: "errorT3",
        temperatureT4: "errorT4",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierNN1: "errorNN1Dehumidifier",
        malfunctionDehumidifierNN2: "errorNN2Dehumidifier",
        malfunctionDehumidifierNN3: "errorNN3Dehumidifier",
        malfunctionDehumidifierNN4: "errorNN4Dehumidifier",
        malfunctionDehumidifierNT1: "errorNT1Dehumidifier",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityNN1Dehumidifier: "humidityTooltipErrorNN1Dehumidifier",
        humidityNN2Dehumidifier: "humidityTooltipErrorNN2Dehumidifier",
        humidityNN3Dehumidifier: "humidityTooltipErrorNN3Dehumidifier",
        humidityNN4Dehumidifier: "humidityTooltipErrorNN4Dehumidifier",
        humidityNT1Dehumidifier: "humidityTooltipErrorNT1Dehumidifier",
        humidityN04: "humidityTooltipErrorN04",
        humidityNB12: "humidityTooltipErrorNB12",
        humidityNB8: "humidityTooltipErrorNB8",
        humidityNB5: "humidityTooltipErrorNB5",
        humidityNB2: "humidityTooltipErrorNB2",
        humidityNZ1: "humidityTooltipErrorNZ1",
        humidityNZ5: "humidityTooltipErrorNZ5",
        humidityNZ8: "humidityTooltipErrorNZ8",
        humidityNZ11: "humidityTooltipErrorNZ11",
        humidityT1: "humidityTooltipErrorT1",
        humidityT2: "humidityTooltipErrorT2",
        humidityT3: "humidityTooltipErrorT3",
        humidityT4: "humidityTooltipErrorT4",
      },

      // //running -> running tool tip
      // dataNameRunningTooltipNameDict: {
      //   runningDehumidifierNN1: "runningTooltipNN1",
      //   runningDehumidifierNN2: "runningTooltipNN2",
      //   runningDehumidifierNN3: "runningTooltipNN3",
      //   runningDehumidifierNN4: "runningTooltipNN4",
      //   runningDehumidifierNT1: "runningTooltipNT1",
      // },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierNN1: "runningClassNN1",
        runningDehumidifierNN2: "runningClassNN2",
        runningDehumidifierNN3: "runningClassNN3",
        runningDehumidifierNN4: "runningClassNN4",
        runningDehumidifierNT1: "runningClassNT1",
      },
      stationIdList: ["5d3d3f64-cae8-4216-8fda-cd38c3cbcf1e", "17790481-8c80-4615-9a98-b844013ac9e9"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if(runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 78px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/hangzhouwan/bridgeLine_north.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 255px;
          left: 335px;
        }

        .station-block-right {
          top: 255px;
          left: 843px;
        }

        .station-block-tower {
          top: 230px;
          left: 586px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .sta-left-left {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-left-right {
          top: 262px;
          left: 303px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-left {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 5px;
            width: 50px;
            transform: rotate(-45deg);
          }
          &::after {
            bottom: -43px;
            left: -2px;
          }
          .state-info {
            right: 2px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-right-right {
          top: 262px;
          left: 811px;
          &::before {
            bottom: -25px;
            left: 33px;
            width: 50px;
            transform: rotate(225deg);
          }
          &::after {
            bottom: -43px;
            left: 75px;
          }
          .state-info {
            right: -220px;
            top: 42px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .sta-tower {
          top: 230px;
          left: 590px;
          &::before {
            bottom: 7px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 24px;
            left: -40px;
          }
          .state-info {
            right: 40px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .sensor-n04 {
          top: 260px;
          left: 85px;
          &::before {
            bottom: 30px;
            left: -52px;
            width: 70px;
            transform: rotate(40deg);
          }
          &::after {
            bottom: 52px;
            left: -59px;
          }
          .state-info {
            right: 70px;
            top: -37px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb12 {
          top: 260px;
          left: 175px;
          &::before {
            bottom: 60px;
            left: -81px;
            width: 120px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 112px;
            left: -65px;
          }
          .state-info {
            right: 82px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb8 {
          top: 260px;
          left: 303px;
          &::before {
            bottom: 89px;
            left: -133px;
            width: 190px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 170px;
            left: -99px;
          }
          .state-info {
            right: 116px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb5 {
          top: 260px;
          left: 403px;
          &::before {
            bottom: 105px;
            left: -133px;
            width: 210px;
            transform: rotate(70deg);
          }
          &::after {
            bottom: 204px;
            left: -78px;
          }
          .state-info {
            right: 95px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nb2 {
          top: 260px;
          left: 503px;
          &::before {
            bottom: 122px;
            left: -130px;
            width: 235px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 237px;
            left: -48px;
          }
          .state-info {
            right: 62px;
            top: -222px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz1 {
          top: 260px;
          left: 642px;
          &::before {
            bottom: 120px;
            left: -70px;
            width: 240px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 233px;
            left: 90px;
          }
          .state-info {
            right: -199px;
            top: -218px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz5 {
          top: 260px;
          left: 780px;
          &::before {
            bottom: 105px;
            left: -62px;
            width: 210px;
            transform: rotate(110deg);
          }
          &::after {
            bottom: 204px;
            left: 79px;
          }
          .state-info {
            right: -189px;
            top: -189px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz8 {
          top: 260px;
          left: 883px;
          &::before {
            bottom: 89px;
            left: -42px;
            width: 190px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 170px;
            left: 101px;
          }
          .state-info {
            right: -210px;
            top: -155px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-nz11 {
          top: 260px;
          left: 985px;
          &::before {
            bottom: 60px;
            left: -23px;
            width: 120px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 112px;
            left: 67px;
          }
          .state-info {
            right: -176px;
            top: -97px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t4 {
          top: 30px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t3 {
          top: 80px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t2 {
          top: 130px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: -33px;
            width: 50px;
            transform: rotate(45deg);
          }
          &::after {
            bottom: 39px;
            left: -40px;
          }
          .state-info {
            right: 56px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sensor-t1 {
          top: 180px;
          left: 590px;
          &::before {
            bottom: 22px;
            left: 0px;
            width: 50px;
            transform: rotate(135deg);
          }
          &::after {
            bottom: 39px;
            left: 42px;
          }
          .state-info {
            right: -152px;
            top: -24px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>